module.exports = __webpack_public_path__ + "img/Pascale_Fung.8341a6e9.png";